import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import FounderConsole from "@/pages/FounderConsole";
import ProjectsPage from "@/pages/ProjectsPage";
import ProjectDetailPage from "@/pages/ProjectDetailPage";
import ConversationsPage from "@/pages/ConversationsPage";
import SessionDetailPage from "@/pages/SessionDetailPage";
import MemoryPage from "@/pages/MemoryPage";
import DecisionsPage from "@/pages/DecisionsPage";
import IdeasPage from "@/pages/IdeasPage";
import TasksPage from "@/pages/TasksPage";
import SettingsPage from "@/pages/SettingsPage";
import GTMCommandCenter from "@/pages/GTMCommandCenter";
import AppShell from "@/components/AppShell";
import { AuthProvider } from "@/auth/AuthProvider";
import AuthGate from "@/auth/AuthGate";
import { ActiveProjectProvider } from "@/context/ActiveProjectContext";

function App() {
    return (
        <div className="App">
            <AuthProvider>
                <AuthGate>
                    <ActiveProjectProvider>
                        <BrowserRouter>
                            <Routes>
                                {/* Founder Console — frozen bespoke layout */}
                                <Route path="/" element={<FounderConsole />} />

                                {/* All other pages share the AppShell */}
                                <Route element={<AppShell />}>
                                    <Route path="/projects" element={<ProjectsPage />} />
                                    <Route path="/projects/:id" element={<ProjectDetailPage />} />
                                    <Route path="/conversations" element={<ConversationsPage />} />
                                    <Route path="/conversations/:id" element={<SessionDetailPage />} />
                                    <Route path="/memory" element={<MemoryPage />} />
                                    <Route path="/decisions" element={<DecisionsPage />} />
                                    <Route path="/ideas" element={<IdeasPage />} />
                                    <Route path="/tasks" element={<TasksPage />} />
                                    <Route path="/gtm" element={<GTMCommandCenter />} />
                                    <Route path="/settings" element={<Navigate to="/settings/voice" replace />} />
                                    <Route path="/settings/:section" element={<SettingsPage />} />
                                </Route>

                                {/* Fallback → console */}
                                <Route path="*" element={<Navigate to="/" replace />} />
                            </Routes>
                        </BrowserRouter>
                    </ActiveProjectProvider>
                </AuthGate>
            </AuthProvider>
        </div>
    );
}

export default App;
